import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IDealerPaymentBlockList } from '../models/models'

export class DealerBlockListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerInformation/getPaymentBlockedDealers',
      requesterInfo,
    })
  }

  public async GetDealerBlock(): Promise<IDealerPaymentBlockList[]> {
    return await this.getAsync<IDealerPaymentBlockList[]>()
  }
}
